import { render, staticRenderFns } from "./PressVideo.vue?vue&type=template&id=0ac8a5da&scoped=true&"
import script from "./PressVideo.vue?vue&type=script&lang=js&"
export * from "./PressVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8a5da",
  null
  
)

export default component.exports